import { render, staticRenderFns } from "./ProductSectionBasicData.vue?vue&type=template&id=47078568&scoped=true"
import script from "./ProductSectionBasicData.vue?vue&type=script&lang=js"
export * from "./ProductSectionBasicData.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionBasicData.vue?vue&type=style&index=0&id=47078568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47078568",
  null
  
)

export default component.exports